import React, { useEffect } from 'react';
import { SheerIdFinePrint } from 'Components/SheerIdFinePrint';
import { useIntervalTimer } from 'Hooks/useIntervalTimer';
import { getMemberVerify } from 'Api/SheerIdService';
import { SHEER_PAGE_TYPES, SHEER_PAGE_TITLES, SHEER_PAGE_STATUS } from 'Utils/SheerIdHelpers';
import BangoBackButton from 'Components/BangoBackButton/BangoBackButton';
import './SheerIdReviewPage.css';

export const SheerIdReviewPage = ({ setPage, setTitle }) => {
  useIntervalTimer(async () => {
    try {
      const response = await getMemberVerify();
      if (SHEER_PAGE_STATUS[response.currentStep] !== SHEER_PAGE_TYPES.REVIEW) {
        setPage(SHEER_PAGE_STATUS[response.currentStep], response);
      }
    } catch (error) {
      setPage(SHEER_PAGE_TYPES.ERROR, error);
    }
    // 20,000 === 20 Seconds
  }, 20000);

  useEffect(() => {
    setTitle(SHEER_PAGE_TITLES[SHEER_PAGE_TYPES.REVIEW]);
  }, [setTitle]);
  return (
    <div className="sheerIdReviewPage">
      <BangoBackButton />
      <h2 className="reviewTitle">Reviewing</h2>
      <div className="reviewInfo">
        <div className="reviewText">
          Turnaround time for your language is typically a few minutes, and in rare times of high volume may take up to
          20 minutes.
        </div>
        <div className="reviewText">Wait here or let us notify you of the outcome.</div>
        <div className="reviewText">You will be contacted via email.</div>
      </div>
      <SheerIdFinePrint isReview />
    </div>
  );
};
